import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { Container, Col, Row } from 'react-bootstrap';
import brandName from '../../../images/Group1.svg';
import PropTypes from 'prop-types';

const LiveNavbar = ({ links }) => {
  return (
    <Fragment>
      <Container className='RecordLabelNav text-capitalize'>
        <Row>
          <Col md={4}>
            <img src={brandName} alt='hello' width='160px' height='100px' />
          </Col>
          <Col md={{ span: 3, offset: 1 }} className={links}>
            <NavLink activeClassName='active' to='/liveExperience'>
              Throwdown Chapter V
            </NavLink>
          </Col>
          <Col className={links}>
            <NavLink activeClassName='active' to='/pastEvents'>
              Past Events
            </NavLink>
          </Col>
          <Col md={2} className={links}>
            <NavLink activeClassName=' btn btn-theam' to='/buyTickets'>
              Buy Tickets
            </NavLink>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

LiveNavbar.defaultProps = {
  links: 'text-center py-2',
};
LiveNavbar.propTypes = {
  links: PropTypes.string.isRequired,
};
export default LiveNavbar;
